import enums from "../enums";
import Service from "../service/index.jsx";
import { setUser } from "../utils";
import { handleError } from "./base.js";

export function getUserInfo(cb) {
	return (dispatch) => {
		Service.get("account-api", "profile")
			.then((response) => {
				dispatch({ type: enums.PROFILE_DATA, payload: response.data });
				if (cb) {
					cb(response.data, dispatch);
				}
			})
			.catch(handleError.bind(this, { dispatch }));
	};
}

export function getInbox(params, cb) {
	return (dispatch, getState) => {
		dispatch({ type: enums.INBOX_LOADING, payload: true });
		Service.get("notification-api", "notifications", { params })
			.then((res) => {
				if (res.data.notifications && res.data.notifications.length > 0) {
					const currentInbox = getState().profile.inbox;
					const newNotifications = res.data.notifications;
					const updatedNotifications = [
						...currentInbox.notifications,
						...newNotifications.filter(
							(notification) =>
								!currentInbox.notifications.some(
									(existingNotification) =>
										existingNotification.submissionTime ===
										notification.submissionTime
								)
						),
					];
					dispatch({
						type: enums.INBOX_LIST,
						payload: {
							...res.data,
							notifications: updatedNotifications,
							isUpdate: !!params.offset,
						},
					});
				}
				dispatch({ type: enums.INBOX_LOADING, payload: false });
				if (cb) {
					cb();
				}
			})
			.catch(
				handleError.bind(this, {
					dispatch,
					cb: () => {
						dispatch({ type: enums.INBOX_LOADING, payload: false });
					},
					title: "ERROR",
					msg: "GENERIC_ERROR",
				})
			);
	};
}

export function adjustInbox(newInbox, cb) {
	return (dispatch) => {
		dispatch({ type: enums.ADJUST_INBOX, payload: newInbox });
		if (cb) {
			cb();
		}
	};
}

export function getNotificationsCount(params, cb) {
	return (dispatch, getState) => {
		dispatch({ type: enums.INBOX_LOADING, payload: true });
		Service.get("notification-api", "notifications/new", { params })
			.then((res) => {
				dispatch({ type: enums.NOTIFICATION_COUNTER, payload: res.data.totalCount });
				if (res.data.notifications && res.data.notifications.length > 0) {
					const currentInbox = getState().profile.inbox;
					const updatedNotifications = [
						...currentInbox.notifications,
						...res.data.notifications,
					];
					dispatch({
						type: enums.INBOX_LIST,
						payload: {
							...res.data,
							notifications: updatedNotifications,
							isUpdate: false,
						},
					});
				}
				if (cb) {
					cb();
				}
			})
			.catch(
				handleError.bind(this, {
					dispatch,
					cb: () => {
						dispatch({ type: enums.INBOX_LOADING, payload: false });
					},
					title: "ERROR",
					msg: "GENERIC_ERROR",
				})
			);
	};
}

export function reduceNotificationCounter() {
	return (dispatch) => {
		dispatch({ type: enums.REDUCE_NOTIFICATION_COUNTER, payload: true });
	};
}

export function setUserInfo(username, payload, cb) {
	return (dispatch, getState) => {
		Service.put("account-api", "profile", payload)
			.then(() => {
				dispatch({ type: enums.PROFILE_UPDATE_REQUIRED, payload: false });
				const currentUser = getState().auth.user;
				const updatedUser = {
					...currentUser,
					updateProfile: false,
				};
				dispatch({
					type: enums.LOGIN_SUCCESS,
					payload: updatedUser,
				});
				setUser(updatedUser);
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "success",
						msg: "PROFILE_UPDATED",
						title: "SUCCESSFULL_TITLE",
					},
				});
				cb();
			})
			.catch(handleError.bind(this, { dispatch, cb, title: "ERROR", msg: "GENERIC_ERROR" }));
	};
}

export function changePassword(username, values, cb) {
	return (dispatch) => {
		Service.post("account-api", "changePassword", values)
			.then(() => {
				cb();
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "success",
						msg: "PASSWORD_UPDATED",
						title: "SUCCESSFULL_TITLE",
					},
				});
				if (cb) {
					cb();
				}
			})
			.catch(handleError.bind(this, { dispatch, cb, title: "ERROR", msg: "GENERIC_ERROR" }));
	};
}

export function setLanguage(params, cb) {
	return (dispatch) => {
		Service.post("account-api", `changeLocale?locale=${params}`)
			.then((response) => {
				console.log(response);
				localStorage.setItem("lang", params);
				document.title = window.TITLE[params];
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "success",
						msg: "LANG_CHANGE_SUCCESS",
						title: "LANG_CHANGE",
					},
				});
			})
			.catch(handleError.bind(this, { dispatch, cb, title: "ERROR", msg: "GENERIC_ERROR" }));
	};
}

export function getAllLogs(queryParams, isUpdate, cb) {
	return (dispatch) => {
		dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: true });

		Service.get("transaction-api", "user/allgames", { params: queryParams })
			.then((response) => {
				dispatch({
					type: isUpdate
						? enums.PROFILE_GAME_HISTORY_LOADED_UPDATE
						: enums.PROFILE_GAME_HISTORY_LOADED,
					payload: response.data,
				});
				dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: false });
				if (cb) {
					cb(response.data);
				}
			})
			.catch(handleError.bind(this, { dispatch }));
	};
}

export function getGameLogs(queryParams, isUpdate, cb) {
	return (dispatch) => {
		dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: true });
		Service.get("transaction-api", "user/othergames", { params: queryParams })
			.then((response) => {
				dispatch({
					type: isUpdate
						? enums.PROFILE_GAME_HISTORY_LOADED
						: enums.PROFILE_GAME_HISTORY_LOADED_UPDATE,
					payload: response.data,
				});
				dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: false });
				if (cb) {
					cb(response.data);
				}
			})
			.catch(
				handleError.bind(this, {
					dispatch,
					loading: enums.PROFILE_HISTORY_CALL_IN_PROGRESS,
				})
			);
	};
}

export function getPaymentLogs(filterType, queryParams, isUpdate, cb) {
	return (dispatch, getState) => {
		dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: true });
		Service.get(
			"transaction-api",
			`user/payments${filterType !== "All" ? `?type=${filterType}` : ""}`,
			{ params: queryParams }
		)
			.then((response) => {
				console.log();
				dispatch({
					type: isUpdate
						? enums.PROFILE_PAYMENT_HISTORY_LOADED_UPDATE
						: enums.PROFILE_PAYMENT_HISTORY_LOADED,
					payload: { ...response.data, wagering: getState().balance.wagering },
				});
				dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: false });
				if (cb) {
					cb(response.data);
				}
			})
			.catch(
				handleError.bind(this, {
					dispatch,
					loading: enums.PROFILE_HISTORY_CALL_IN_PROGRESS,
				})
			);
	};
}

export function getFreespins(cb) {
	return (dispatch) => {
		dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: true });
		Service.get("bonus-api", "bonus/actives?type=freespin")
			.then((response) => {
				dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: false });
				dispatch({ type: enums.PROFILE_FREESPIN_HISTORY_LOADED, payload: response.data });
				if (cb) {
					cb();
				}
			})
			.catch(
				handleError.bind(this, {
					dispatch,
					loading: enums.PROFILE_HISTORY_CALL_IN_PROGRESS,
				})
			);
	};
}

export function getPendingWithdrawLogs(queryParams, isUpdate, cb) {
	return (dispatch) => {
		dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: true });
		Service.get("transaction-api", "user/withdraw/provisions", { params: queryParams })
			.then((response) => {
				dispatch({
					type: isUpdate
						? enums.PROFILE_PENDING_HISTORY_LOADED_UPDATE
						: enums.PROFILE_PENDING_HISTORY_LOADED,
					payload: response.data,
				});
				dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: false });
				if (cb) {
					cb(response.data);
				}
			})
			.catch(
				handleError.bind(this, {
					dispatch,
					loading: enums.PROFILE_HISTORY_CALL_IN_PROGRESS,
				})
			);
	};
}

export function getSportsbookLogs(queryParams, isUpdate, cb) {
	return (dispatch) => {
		dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: true });
		Service.get("transaction-api", "user/payments", { params: queryParams })
			.then((response) => {
				console.log(response);
				dispatch({
					type: isUpdate
						? enums.PROFILE_HISTORY_LOADED_UPDATE
						: enums.PROFILE_HISTORY_LOADED,
					payload: response.data,
				});
				dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: false });
				if (cb) {
					cb();
				}
			})
			.catch(handleError.bind(this, { dispatch }));
	};
}

export function getProfileHistory(
	type,
	{ startDate, endDate, size, lastItem },
	filterType,
	isUpdate,
	cb
) {
	startDate = startDate?.valueOf();
	endDate = endDate?.valueOf();
	let queryParams = { size, lastItem, startDate, endDate };
	if (type === "ALL" || type == "game" || type === null) {
		return getAllLogs(queryParams, isUpdate, cb);
	} else if (type === "PAYMENT" || type == "deposit") {
		return getPaymentLogs(filterType, queryParams, isUpdate, cb);
	} else if (type === "GAME") {
		return getGameLogs(queryParams, isUpdate, cb);
	} else if (type === "PENDING WITHDRAW" || type === "pending_withdraw") {
		return getPendingWithdrawLogs(queryParams, isUpdate, cb);
	} else {
		return dispatch({ type: enums.PROFILE_HISTORY_CALL_IN_PROGRESS, payload: true });
	}
}
